import React from "react";
import MenuNav from "../../components/portfolio/menu-nav.component";
import PortfolioFooter from "../../components/portfolio/portfolio-footer.component";
import Divider from "../../components/portfolio/divider.component";

import "./contact.styles.css";
import AutoDownload from "../resume/resume.component";
import Navbar from "../../components/navbar/navbar.component";

const Contact = () => (
  <div>
    <Navbar/>
  <div className="page-wrapper">
    <section className="page-section contact-page">
      <h1 className="page-title">Contact</h1>
      <div className="contact-grid">
        <div className="contact-card">
          <div className="h4 gold">Email</div>
          <a href="mailto:pankajvyas033@gmail.com" className="h3 contact-value">
            pankajvyas033@gmail.com
          </a>
        </div>

        <div className="contact-card">
          <div className="h4 gold">Location</div>
          <p className="h3 contact-value">Bangalore, India</p>
        </div>
      </div>
    </section>
    <Divider />
    </div>
    <PortfolioFooter/>
  </div>
);

export default Contact;
